<template>
    <SecondaryPage :showLangSwitchBtn="false">
        <div class="max-w-sm m-auto p-6">
            <div class="text-center text-18 font-bold text-a-brown-502314">
                <span v-if="isStatePassword">{{lbl.register.setup_pin}}</span>
                <span v-else>{{lbl.register.confirm_pin}}</span>
            </div>
            <div class="py-3">
                <img class="m-auto w-8" src="../../../assets/password/ic-lock.svg">
            </div>
            <div class="text-a-brown-502314 text-14 text-center mb-10">
                {{lbl.register.enter_pin}}
            </div>

            <div v-if="isStatePassword">
                <InputPin ref="input-password" v-model:inputValue="password" @onEnter="onEnterPassword()"></InputPin>

                <div class="btn-submit-area mt-8 mx-auto">
                    <RedButton @click="clickSubmitPassword()">Submit</RedButton>
                </div>
            </div>
            <div v-else>
                <InputPin ref="input-confirm" v-model:inputValue="confirmPass" @onEnter="onEnterConfirmPassword()"></InputPin>

                <div class="btn-submit-area mt-8 mx-auto">
                    <RedButton @click="clickConfirmPassword()">Confirm</RedButton>
                </div>
            </div>
        </div>
    </SecondaryPage>
</template>
<script>
import Util from '@/helper/Utility'
import Account from '@/helper/AccountHelper.js';
import CacheHelper from '@/helper/CacheHelper';
import { CacheKey } from '@/helper/StaticValue';
import FBFunction from '@/helper/facade/FBFunction';
import Locale from "@/helper/locale/Locale.js";
//component
import SecondaryPage from '@/components/Layout/Page/SecondaryPage.vue'
import RedButton from '@/components/Button/RedButton.vue';
import InputPin from '@/components/Input/simple/InputPin.vue';
import { RegisterModel } from '../model/RegisterModel';
//mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from "@/mixin/LocaleMixin.js";
//service
import RegisterApi from '../service/RegisterApi';
import { AuthLoginConfigBuilder, AuthFacebookConfigBuilder, AuthGoogleConfigBuilder } from '@/core/Account/config/AuthConfigModel';
import BzbsAuth from '@/core/Account/service/BzbsAuth';
import ConnectSocialAccountApi from '@/module/Profile/service/ConnectSocialAccountApi';
import BzbsProfile from '@/core/Account/service/BzbsProfile.js';
//composable
import useFirebaseAuth from '@/module/Login/composable/useFirebaseAuth'

export default {
    mixins: [ModalMixin,LocaleMixin],
    components: {
        SecondaryPage,
        RedButton,
        InputPin,
    },
    data: function () {
        return {
            registerModel: new RegisterModel(),
            password: '',
            confirmPass: '',
            traces: null,
            badges: null,

            state: 'password', // password, confirmPass
            pathAfterLogin: null,
        };
    },
    computed: {
        isStatePassword: function () {
            return this.state == 'password';
        },
    },
    setup: function () {
        const googleAuth = useFirebaseAuth()
        return {
            googleAuth
        }
    },
    created: function() {
        this.loadCacheRegister();
        let afterLogin = this.$route.query.afterLogin;
        if (!Util.isEmptyStr(afterLogin)) {
            this.pathAfterLogin = afterLogin;
        }

        setTimeout(()=> {
            this.$refs['input-password'].focus();
        },200);

        if (this.registerModel.isLoadGoogle) {
            this.modal.loadingModal.show();
        }
        this.checkLoginGoogle();
    },
    methods: {
        onEnterPassword: function() {
            this.clickSubmitPassword();
        },
        onEnterConfirmPassword: function() {
            this.clickConfirmPassword();
        },
        clickSubmitPassword: function () {
            if (this.password.length != 6) {
                return;
            }

            this.state = 'confirmPass';
            setTimeout(()=> {
                this.$refs['input-confirm'].focus();
            },200);
        },
        clickConfirmPassword: function () {
            if (this.confirmPass.length != 6 || this.confirmPass != this.password) {
                this.modal.errorModal
                    .clearModal()
                    .setMsg(this.lbl.register.pin_not_match)
                    .show();
                this.resetState();
                return;
            }

            this.flowRegister();
        },
        resetState: function () {
            this.$refs['input-confirm'].clearInput();
            this.state = 'password';
            this.$nextTick(() => {
                this.$refs['input-password'].clearInput();
            });
        },

        flowRegister: async function () {
            // this.loadCacheRegister();
            this.registerModel.setPassword(this.password);
            this.registerModel.setConfirmPassword(this.confirmPass);

            let paramsRegister = this.registerModel.getParams();
            console.log('params register', paramsRegister);

            this.modal.loadingModal.show();
            let registerRs = await this.apiRegister(paramsRegister);
            if (!registerRs) {
                this.modal.loadingModal.hide();
                return;
            }

            

            let loginRs = await this.apiLogin();
            if (!loginRs) {
                return;
            }

            if (this.registerModel.isFacebookRegister) {
                let fbAccessToken = await this.getFacebookAccessToken();
                await this.apiConnectFacebook(fbAccessToken);
            }

            if (this.registerModel.isGoogleRegister) {
                this.registerModel.isLoadGoogle = true;
                this.saveCacheRegister();
                this.googleAuth.signInWithRedirect();
            } else {
                this.setSuccessLogin();
            }
        },
        setSuccessLogin: async function() {
            this.clearCacheRegister();
            
            let localeCodeCurrent = Locale.getLocaleCode();
            if (this.localeCode != localeCodeCurrent) {
                await this.setupLocale();
            }

            this.modal.loadingModal.hide();
            if (this.pathAfterLogin != null) {
                window.location.replace('/register/success?afterLogin=' + this.pathAfterLogin);
            } else {
                window.location.replace('/register/success');
            }
        },
        saveCacheTraces: function () {
            let cache = new CacheHelper('session');
            cache.setCache(CacheKey.traces, this.traces);
        },
        
        saveCacheRegister: function () {
            let cache = new CacheHelper('session');
            cache.setCache(CacheKey.formRegister, this.registerModel);
        },
        loadCacheRegister: function () {
            let cache = new CacheHelper('session');
            let cacheRegister = cache.getCache(CacheKey.formRegister);

            if (cacheRegister != null) {
                this.registerModel.setValueFromCache(cacheRegister);
            }
        },
        clearCacheRegister: function () {
            let cache = new CacheHelper('session');
            cache.removeCache(CacheKey.formRegister)
        },
        setupLocale: function() {
            return new Promise((resolve) => {
                BzbsProfile.changeLocale(this.localeCode).subscribe({
                    next: (data) => {
                        console.log(data.data);
                        Account.updateToken(data.data);
                        Locale.setLocale(this.localeCode);
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err);
                        resolve(false);
                        this.errorApi(err);
                    },
                })
            })
        },
        apiRegister: function (params) {
            return new Promise((resolve) => {
                RegisterApi.apiRegister(params).subscribe({
                    next: (data) => {
                        console.log(data);
                        if (data.buzzebees && data.buzzebees.traces) {
                            this.traces = data.buzzebees.traces;
                            this.saveCacheTraces();
                        }
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err);
                        resolve(false);
                        this.errorApi(err);
                    },
                })
            })
        },

        apiLogin: function () {
            return new Promise((resolve) => {
                let loginParams = new AuthLoginConfigBuilder()
                    .setUsername(this.registerModel.email)
                    .setPassword(this.registerModel.password)
                    .create()
                    .getParams()
                BzbsAuth.apiLogin(loginParams).subscribe({
                    next: (data) => {
                        console.log(data);
                        Account.setLogin(data);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        //#region Fackbook
        getFacebookAccessToken: function () {
            return new Promise((resolve) => {
                let fb = new FBFunction();
                fb.getLoginStatus().then((data) => {
                    let accessToken = data?.accessToken;
                    resolve(accessToken);
                }).catch(() => {
                    resolve(null);
                });
            });
        },
        
        apiConnectFacebook: function (facebookAccessToken) {
            return new Promise((resolve) => {
                if (facebookAccessToken == null) {
                    resolve(false);
                    return;
                }

                let token = Account.getToken();
                let params = new AuthFacebookConfigBuilder()
                    .genUUID()
                    .setFacebookToken(facebookAccessToken)
                    .setDeviceToken(token)
                    .create()
                    .getParams();
                ConnectSocialAccountApi.apiConnectFacebook(params).subscribe({
                    next: (data) => {
                        console.log('connect facebook', data);
                        Account.setLogin(data);
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err);
                        resolve(false);
                    },
                })
            });
        },
        //#endregion Facebook
        //#region Google
        getGoogleIdToken: function () {
            return new Promise((resolve) => {
                this.googleAuth.getGoogleIdToken().then((token)=>{
                    console.log("id-token",token);
                    resolve(token);
                });
            });
        },
        checkLoginGoogle: async function () {
            this.googleAuth.getRedirectResult().then((token)=>{
                if (token && token.idToken) {
                    this.loginGoogleBzbs(token.idToken)
                }
            });
        },
        loginGoogleBzbs: async function(ggAccessToken) {
            if (await this.apiConnectGoogle(ggAccessToken)) {
                this.setSuccessLogin();
            }
        },
        apiConnectGoogle: async function (ggAccessToken) {
            return new Promise((resolve) => {
                if (ggAccessToken == null) {
                    resolve(false);
                    return;
                }

                let token = Account.getToken();
                let params = new AuthGoogleConfigBuilder()
                    .genUUID()
                    .setGoogleToken(ggAccessToken)
                    .setDeviceToken(token)
                    .create()
                    .getParams();

                BzbsAuth.apiLoginGoogle(token,params).subscribe({
                    next: (user) => {
                        console.log('connect google',user);
                        Account.setLogin(user);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                })
            });
        },
        //#endregion Google
    },
}
</script>
<style lang="scss" scoped>
    .btn-submit-area {
        max-width: 255px;
    }
</style>
